/**
 * Enum for booking status values
 * Used across the application for consistent booking status handling
 * Applies to visits, tests, appointments, prescriptions, etc.
 */
export enum BookingStatus {
  SCHEDULED = "scheduled",
  PENDING = "pending",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
  COMPLETING = "completing",
  VALIDATED = "validated",
  MISSED = "missed"
}

/**
 * Type alias for booking status values
 * Use this for function parameters and return types
 */
export type BookingStatusType = BookingStatus;

/**
 * Get the label for a booking status.
 * @param status the status value, typically from the DTO.
 * @returns the label for the booking status.
 */
export function getBookingStatusLabel(status: BookingStatusType): string {
  switch (status) {
    case BookingStatus.SCHEDULED:
      return "Prenotato";
    case BookingStatus.PENDING:
      return "In attesa di prenotazione";
    case BookingStatus.COMPLETED:
      return "Concluso";
    case BookingStatus.CANCELLED:
      return "Annullato";
    case BookingStatus.COMPLETING:
      return "In fase di completamento";
    case BookingStatus.VALIDATED:
      return "Validato";
    case BookingStatus.MISSED:
      return "Non presente";
    default:
      return "Unknown";
  }
}
